<template>
    <div id="paper_size" class="field">
        <label>
            {{ $t('ui.toolbox.core_waybills_label_svg.labels.paper_size') }}
        </label>

        <select class="ui selection dropdown"
            v-model="current_paper_size"
            v-dropdown>
            <option v-for="itme in itmes" :value="itme.value">
                {{ itme.name }}
            </option>
        </select>

        <!-- <div v-dropdown class="ui selection dropdown">
            <div class="text">
                {{ paper_size }}
            </div>
            <i class="dropdown icon"></i>
            <div class="menu">
                <div
                    v-for="itme in itmes"
                    @click="paper_size = itme.value"
                    class="item"
                    :class="{
                        'selected active': paper_size == itme.value
                    }">
                    {{ itme.name }}
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>

export default {
    name: "ToolCoreWaybillsLabelSvgNewLabelPaperSize",
    props: {
        channel: String,
        paper_size: {
            type: String,
            default: "A4"
        },
        scope: {
            type: String,
            default: "provider"
        }
    },
    data() {
        return {
            is_initialized: false,
            is_processing: true,
            current_paper_size: "",
            itmes: [
                {
                    name: "A3",
                    value: "A3",
                    sort: 0,
                },
                {
                    name: "A4",
                    value: "A4",
                    sort: 1,
                }
            ],
        }
    },
    computed: {
        papers_label_infos() {
            return this.$store.state[this.scope].papers_label_infos || {}
        },
    },
    created() {
    },
    mounted() {
        _.forEach(this.papers_label_infos, (label_info) => {
            if (label_info.style) {
                let size = `${label_info.style.height}x${label_info.style.width}`
                if (
                    !_.findLast(this.itmes, (itme) => {
                        return itme.value == size
                    })
                ) {
                    this.itmes.push({
                        name: `${size}mm`,
                        value: size,
                        sort: Number(label_info.style.height)
                    })
                }
            }
        })

        this.itmes = _.sortBy(this.itmes, 'sort')
    },
    watch: {
        paper_size: {
            immediate: true,
            handler(value) {
                this.current_paper_size = value
            }
        },
        current_paper_size(value) {
            if (this.channel) {
                this.$bus.$emit(this.channel, value)
            }
        }
    },
    methods: {
    },
    components: {
    },
}
</script>

<style scoped lang="scss">

</style>
